export default {
    cn: {
        title: '对选择文本...',
        underline: '划重点',
        comment: '注释',
        viewComment: '查看注释',
        similar: '语义搜索',
        cancel: '取消划选',
        quickComment: '快捷注释',
        compare: '搜寻相似段',
        tooltip: '<span><b>使用划段功能的注意事项：</b></span>' +
            '<span>1. 请至少划选2个字符，但一次不超过2000字符</span>' +
            '<span>2. 图片、数学公式或一些特殊格式的文本暂不支持划选</span>' +
            '<span>3. 请尽量不要在使用浏览器翻译插件（例如谷歌翻译）时划选翻译文本，一旦翻译更新，划选过的内容可能会丢失</span>' +
            '<span>4. 在被分享的工作空间划重点或注释，可以在空间创建者和分享者之间协同分享</span>' +
            '<span>5. 所有划过重点和注释过的专利都会自动保存在“快速保存 > 划过重点/注释过的专利”工作空间中，您可以随时查询</span>',
    },
    en: {
        title: 'I want to...',
        underline: 'Underline',
        comment: 'Comment',
        viewComment: 'View comment',
        similar: 'Semantic',
        cancel: 'Remove underline',
        quickComment: 'Shortcut comments',
        compare: 'Find similarities',
        tooltip: '<span><b>Please note when using the paragraph underline function:</b></span>' +
            '<span>1. Underline a minimum of 2 characters and maximum of 2000 characters at any single time</span>' +
            '<span>2. Images, mathematical formulas, and some special formatted text are not supported</span>' +
            '<span>3. Please do not select the text when using a browser translation plug-in (such as Google Translation). The selected content may be lost once the translation updates</span>' +
            '<span>4. Underlined and commented paragraphs in Workspace patents can be shared collaboratively between the Workspace owner and the recipient</span>' +
            '<span>5. Underlined/Commented patents will be saved automatically in a Workspace named "Quick Save > Underlined/Commented patents"</span>',
    },
    jp: {
        title: 'したい...',
        underline: '下線',
        comment: 'コメント',
        viewComment: 'コメントを見る',
        similar: 'セマンティック検索',
        cancel: '下線を解除',
        quickComment: 'クイックコメント',
        compare: '類似した段落を検索する',
        tooltip: '<span><b>下線付きの機能について：</b></span>' +
            '<span>1. 下線を引く場合、文字数は最低2文字、毎回2000文字を超えないように選択してください</span>' +
            '<span>2. 画像や数式やまたはいくつかの特殊なフォーマットのテキストは、下線付きをサポートしていません</span>' +
            '<span>3. ブラウザ翻訳プラグイン（Google翻訳等）を利用する際は訳文テキストに下線付きを使用しないようにしてください。訳文を更新すると下線を引いた内容が失われる可能性があります</span>' +
            '<span>4. 下線付き又はコメント付きの内容は、ワークスペースの作成者と共有者の間で共有されます</span>' +
            '<span>5. 下線付き又はコメント付きの特許は自動的にワークスペースの「クイックセーブ＞下線・コメント付きの特許」フォルダーに保存されますので、いつでも確認できます</span>',
    },
    tw: {
        title: '對選擇文字...',
        underline: '劃重點',
        comment: '註釋',
        viewComment: '查看註釋',
        similar: '語義搜索',
        cancel: '取消劃選',
        quickComment: '快捷註釋',
        compare: '搜尋相似段',
        tooltip: '<span><b>使用劃段功能的注意事項：</b></span>' +
            '<span>1. 請至少劃選2個字符，但一次不超過2000字符</span>' +
            '<span>2. 圖片、數學公式或一些特殊格式的文本暫不支持劃選</span>' +
            '<span>3. 請盡量不要在使用瀏覽器翻譯插件（例如穀歌翻譯）時劃選翻譯文本，一旦翻譯更新，劃選過的內容可能會丟失</span>' +
            '<span>4. 在被分享的工作空間劃重點或註釋，可以在空間創建者和分享者之間協同分享</span>' +
            '<span>5. 所有劃過重點和註釋過的專利都會自動保存在“快速保存 > 劃過重點/註釋過的專利”工作空間中，您可以隨時查詢</span>',
    },
};
